import { useMutation } from '@apollo/client'

import { CreateBuyListProductDocument } from '@/graphql/purchase-plus/generated/createBuyListProduct.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'

export default function useCreateBuyListProduct() {
  const mutation = useMutation(CreateBuyListProductDocument, {
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
  })

  return mutation
}
